import { render, staticRenderFns } from "./surface-properties-detail.vue?vue&type=template&id=5a736ac5&"
import script from "./surface-properties-detail.vue?vue&type=script&lang=js&"
export * from "./surface-properties-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports